import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'non-access-template',
  standalone: true,
  imports: [],
  templateUrl: './non-access-template.component.html',
  styleUrl: './non-access-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NonAccessTemplateComponent {
  template;
  constructor(@Inject(MAT_DIALOG_DATA) public data, private dialogRef: MatDialogRef<NonAccessTemplateComponent>) {
    this.template = data.template;
  }
  ngOnInit(): void {}
  closeDialog() {
    this.dialogRef.close();
  }
}
